import "./main.scss";
import "@popperjs/core";
import "bootstrap";

import { createApp } from 'vue';
import { createPinia } from 'pinia';
// import { maska } from 'maska';

import Home from "../components/views/Home.vue";
import Results from "../components/views/Results.vue";
import Confirmation from "../components/views/Confirmation.vue";
import ResultsConfirmation from "../components/views/ResultsConfirmation.vue";

// import vSelect from 'vue-select'
// import vueCountryRegionSelect from 'vue3-country-region-select'

if (document.querySelector('#pledge')) {
  const home = createApp(Home);
  home.use(createPinia());
  home.mount('#pledge');
}

if (document.querySelector('#results')) {
  const home = createApp(Results);
  home.use(createPinia());
  home.mount('#results');
}

if (document.querySelector('#results_confirmation')) {
  const home = createApp(ResultsConfirmation);
  home.use(createPinia());
  home.mount('#results_confirmation');
}

if (document.querySelector('#pledge_confirmation')) {
  const home = createApp(Confirmation);
  home.use(createPinia());
  home.mount('#pledge_confirmation');
}